/* global axios */
import ApiClient from '../ApiClient';

class CrmTasksClient extends ApiClient {
  constructor() {
    super('kanban/tasks', { accountScoped: true });
  }

  get(params = {}, { signal } = {}) {
    return axios.get(this.url, { params, signal });
  }
}

export default new CrmTasksClient();
